// import axios from '@axios'
import useJwt from '@/auth/jwt/useJwt'
// import { reject, resolve } from 'core-js/fn/promise'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // fetchTransactions(ctx, queryParams) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .get('/company/payments', { params: queryParams })
    //       .then(response => resolve(response))
    //       .catch(error => reject(error))
    //   })
    // },
    fetchTransactions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        useJwt.historyCompanyPlans(queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
